import Vue from "vue";
import Router from "vue-router";

let comps = {};
const req = require.context("../pages/", true, /\.(js|vue)$/);
req.keys().map(key => {
  const name = key.match(/\w+\./)[0].match(/\w+/)[0];
  comps[name] = req(key).default;
});

Vue.use(Router);
export default new Router({
  mode: "history",
  routes: [
    //默认跳转页
    { path: "", redirect: "/index" },
    //首页
    { path: "/index", name: "index", component: comps.index, meta: { requiresAuth: false, roles: ['staff', 'customer'] } },
    //登陆页
    { path: "/login", name: "login", component: comps.login, meta: { requiresAuth: false, roles: ['staff', 'customer'] } },

    // //影片库页
    { path: "/movieLib", name: "movieLib", component: comps.movieLib, meta: { requiresAuth: true, roles: ['staff', 'customer'] } },
    // { path: "/search", name: "search", component: comps.search, meta: { requiresAuth: true, roles: ['staff', 'customer'] } },
    { path: "/movies", name: "movies", component: comps.movie_compaire_detail, meta: { requiresAuth: true, roles: ['staff', 'customer'] } },
    { path: "/report", name: "report", component: comps.report, meta: { requiresAuth: true, roles: ['staff', 'customer'] } },

    // //我的页
    // { path: "/mine", name: "mine", component: comps.mine, meta: { requiresAuth: false, roles: ['staff', 'customer'] } },
    // { path: "/userInfo", name: "userInfo", component: comps.userInfo, meta: { requiresAuth: false, roles: ['staff', 'customer'] } },
    // { path: "/aboutUs", name: "aboutUs", component: comps.aboutUs, meta: { requiresAuth: false, roles: ['staff', 'customer'] } },
    // { path: "/guide", name: "guide", component: comps.guide, meta: { requiresAuth: false, roles: ['staff', 'customer'] } },
    // //notfound页
    // // { path: "/page_404", name: "404", component: comps.Page_404, meta: { requiresAuth: false, roles: ['staff', 'customer'] } },
    // { path: "*", redirect: "/page_404", meta: { requiresAuth: false, roles: ['staff', 'customer'] } }
  ]
});
